import { Image, Page, View } from '@react-pdf/renderer';
import groupBy from 'lodash.groupby';

import { fileToBase64 } from '@/utils/file-to-base64';

import { PDFBatchFormatType } from './format-batches';

export const SingleMeasurement = ({ images, histogram, table }: PDFBatchFormatType) => {
  const groupedImages = Object.entries(groupBy(images, 'taskId'));

  return (
    <>
      <Page size="A4" style={{ fontFamily: 'Roboto', padding: 30, fontSize: 12 }}>
        <View>
          {table}
          {histogram && <Image source={fileToBase64(histogram)} />}
        </View>
      </Page>
      <Page size="A4" style={{ fontFamily: 'Roboto', padding: 30, fontSize: 12 }}>
        {groupedImages.map(([taskId, imgs]) => (
          <View key={taskId} style={{ display: 'flex', flexDirection: 'row' }}>
            <Image
              source={fileToBase64(imgs[0].image)}
              style={{
                flex: 1,
                marginBottom: 5,
                paddingLeft: 5,
                paddingVertical: 5,
                backgroundColor: '#cad8e5',
              }}
            />
            <Image
              source={fileToBase64(imgs[1].image)}
              style={{
                flex: 1,
                marginBottom: 5,
                paddingVertical: 5,
                paddingHorizontal: 5,
                backgroundColor: '#cad8e5',
              }}
            />
          </View>
        ))}
      </Page>
    </>
  );
};
